import { apiClient } from '@/http/apiClient';
const rootPath = "Import";

class ImportService {
  public async importTranslations(file: FormData) {
    return await apiClient.post(`${rootPath}/ImportTranslationsFile`, file, {
      headers: { "content-type": "multipart/form-data" },
    });
  }
  public async importBopModel(file: FormData) {
    return await apiClient.post(`${rootPath}/ImportBopModel`, file, {
      headers: { "content-type": "multipart/form-data" },
    });
  }

  public async ImportUsers(file : FormData) {
    return await apiClient.post(`${rootPath}/ImportUsersFile`, file, {
      headers: { "content-type": "multipart/form-data" },
    });
  }
}

export default new ImportService();
